import React from "react";

const style = {
  span: {
    backgroundColor: 'rgb(235, 235, 235)',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '8px 16px',
    borderRadius: '16px',
    margin: '4px',
    display: 'inline-block',
  }
}

const Badge = (props) => {
  return <span style={{ ...style.span, ...props.style }}>{props.data}</span>
}

export default Badge;